import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.ogestyle.com";

const ComingSoonPage = ({ countryName, countryCode, source = "homepage" }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    interestedIn: "customer",
    businessType: "",
    phone: "",
    city: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Log interest when component mounts
  React.useEffect(() => {
    const logInterest = async () => {
      try {
        await axios.post(`${API_BASE_URL}/api/waitlist/country/log-interest`, {
          country: countryCode,
          source: source,
        });
      } catch (err) {
      }
    };

    if (countryCode && countryCode !== "US") {
      logInterest();
    }
  }, [countryCode, source]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/waitlist/country/join`,
        {
          ...formData,
          country: countryCode,
          source: source,
        },
      );

      if (response.data.success) {
        setSubmitted(true);
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Failed to join waitlist. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  if (submitted) {
    return (
      <div
        style={{
          minHeight: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "40px 20px",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            width: "100%",
            background: "white",
            borderRadius: "16px",
            padding: "60px 40px",
            textAlign: "center",
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
          }}
        >
          <div
            style={{
              fontSize: "64px",
              marginBottom: "20px",
            }}
          >
            ✅
          </div>

          <h2
            style={{
              fontSize: "32px",
              marginBottom: "16px",
              color: "#1a659e",
            }}
          >
            You're on the List!
          </h2>

          <p
            style={{
              fontSize: "18px",
              color: "#666",
              marginBottom: "30px",
            }}
          >
            Thank you for your interest! We'll notify you as soon as OGESTYLE
            launches in {countryName}.
          </p>

          <div
            style={{
              padding: "20px",
              background: "#f0f9ff",
              borderRadius: "8px",
              marginBottom: "30px",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "#1a659e",
                margin: 0,
              }}
            >
              💡 <strong>Business Owner?</strong> We're looking for early
              partners in {countryName}.<br />
              Check your inbox soon for exclusive benefits!
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "60px 20px",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      }}
    >
      <div
        style={{
          maxWidth: "700px",
          width: "100%",
          background: "white",
          borderRadius: "16px",
          padding: "60px 40px",
          boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <div
            style={{
              fontSize: "64px",
              marginBottom: "20px",
            }}
          >
            🌍
          </div>

          <h1
            style={{
              fontSize: "36px",
              marginBottom: "16px",
              color: "#1a659e",
              fontWeight: "700",
            }}
          >
            Coming Soon to {countryName}!
          </h1>

          <p
            style={{
              fontSize: "18px",
              color: "#666",
              lineHeight: "1.6",
            }}
          >
            OGESTYLE is currently only available in the{" "}
            <strong>United States</strong>.
            <br />
            We're expanding to {countryName} soon and we'd love to have you!
          </p>
        </div>

        {/* Waitlist Form */}
        <div
          style={{
            background: "#f8fafc",
            padding: "30px",
            borderRadius: "12px",
            marginBottom: "30px",
          }}
        >
          <h3
            style={{
              fontSize: "20px",
              marginBottom: "20px",
              color: "#1a659e",
              textAlign: "center",
            }}
          >
            Join the Waitlist
          </h3>

          <p
            style={{
              fontSize: "14px",
              color: "#666",
              textAlign: "center",
              marginBottom: "24px",
            }}
          >
            Be the first to know when we launch in {countryName}!
          </p>

          {error && (
            <div
              style={{
                padding: "12px",
                background: "#fee2e2",
                color: "#991b1b",
                borderRadius: "8px",
                marginBottom: "20px",
                fontSize: "14px",
              }}
            >
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: "16px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#374151",
                }}
              >
                Full Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "16px",
                }}
                placeholder="John Doe"
              />
            </div>

            <div style={{ marginBottom: "16px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#374151",
                }}
              >
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "16px",
                }}
                placeholder="john@example.com"
              />
            </div>

            <div style={{ marginBottom: "16px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#374151",
                }}
              >
                I'm interested as a... *
              </label>
              <select
                name="interestedIn"
                value={formData.interestedIn}
                onChange={handleChange}
                required
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "16px",
                  background: "white",
                }}
              >
                <option value="customer">Customer (Book appointments)</option>
                <option value="business_owner">
                  Business Owner (Salon, Barbershop, Spa)
                </option>
                <option value="freelancer">
                  Freelance Professional (Hair, Nails, Beauty)
                </option>
                <option value="other">Other</option>
              </select>
            </div>

            {formData.interestedIn === "business_owner" && (
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    marginBottom: "8px",
                    color: "#374151",
                  }}
                >
                  Business Type
                </label>
                <input
                  type="text"
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleChange}
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e5e7eb",
                    borderRadius: "8px",
                    fontSize: "16px",
                  }}
                  placeholder="e.g., Hair Salon, Barbershop, Spa"
                />
              </div>
            )}

            <div style={{ marginBottom: "16px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#374151",
                }}
              >
                Phone (Optional)
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "16px",
                }}
                placeholder="+1 234 567 8900"
              />
            </div>

            <div style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  fontSize: "14px",
                  fontWeight: "600",
                  marginBottom: "8px",
                  color: "#374151",
                }}
              >
                City (Optional)
              </label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e5e7eb",
                  borderRadius: "8px",
                  fontSize: "16px",
                }}
                placeholder="Toronto, London, Lagos..."
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%",
                padding: "16px",
                background: loading
                  ? "#9ca3af"
                  : "linear-gradient(135deg, #1a659e 0%, #2980b9 100%)",
                color: "white",
                border: "none",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "600",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
              }}
            >
              {loading ? "Joining..." : "🚀 Join the Waitlist"}
            </button>
          </form>
        </div>

        {/* Contact Info */}
        <div
          style={{
            textAlign: "center",
            padding: "24px",
            background: "#f0f9ff",
            borderRadius: "12px",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "#1a659e",
              marginBottom: "12px",
            }}
          >
            <strong>Business Inquiries</strong>
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "#666",
              marginBottom: "8px",
            }}
          >
            Interested in partnering with us or bringing OGESTYLE to your
            business?
          </p>
          <a
            href="mailto:business@ogestyle.com?subject=Partnership%20Inquiry%20-%20{countryName}"
            style={{
              display: "inline-block",
              padding: "10px 24px",
              background: "white",
              color: "#1a659e",
              border: "2px solid #1a659e",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "14px",
              marginTop: "12px",
              transition: "all 0.3s ease",
            }}
          >
            📧 business@ogestyle.com
          </a>
        </div>

        {/* Footer */}
        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            paddingTop: "20px",
            borderTop: "1px solid #e5e7eb",
          }}
        >
          <p
            style={{
              fontSize: "12px",
              color: "#9ca3af",
            }}
          >
            Currently available in: 🇺🇸 United States
          </p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoonPage;
